export default {
    en: {
        report_type: "Type Report",
        product: "Product",
        driver: "Driver",
        user: "User",
        generate_by: "Generate By",
        time_filter: "Time Filter",
        bottles_dispatched: "Bottles Dispatched",
        empty_bottles: "Empty Bottles",
        bottles_full_back: "Bottles Full Back",
        damaged_bottles: "Damaged Bottles",
        total_credit_cards: "Total Credit Cart",
        total_checks: "Total Checks",
        total_pending_credits: "Total Pending Credit",
        total_bottles: "Total Bottles",
        total_sold: "Total Sold",
        weekly_income: "Weekly Income",
        active: "Active",
        prepared: "Prepared",
        created_at: "Created",
        search: "Search",
        import: "Import",
        export: "Export",
        base_file: "Base File",
        results: "Results",
        from: "From",
        to: "To",
        filter: "Filter",
        comment: "Comment",
        button: {
            create: "Create",
            update: "Update",
            edit: "Edit",
            details: "Details",
            delete: "Delete",
            cancel: "Cancel",
            accept: "Accept",
            activate: "Activate",
            options: "Options",
            back: "Back",
            print: "Print"
        },
        fields: {
            name: "Name",
            address: "Address",
            address2: "Apt / Floor",
            state: "State",
            city: "City",
            zipcode: "Zip Code",
            phone: "Phone",
            phone2: "Phone 2",
            order_frequency: "Order Frequency",
            check_frequency: "Enable Frequency",
            active: "Active",
            is_active: "Is @:fields.active",
            inactive: "Inactive",
            comment: "Comment",
            price: "Price",
            driver: "Driver",
            order_date: "Order Date",
            payment_type: "Payment Type",
            amount: "Amount",
            attended_by: "Attended by",
            expense: "Expense",
            expense_type: "@:fields.expense Type"
        },
        clients: {
            label: "Client",
        },
        orders: {
            label: "Order",
            fields: {
                driver: "Driver",
                order_date: "Order Date",
                payment_type: "Payment Type",
                delivery_type: "Delivery Type",
                quantity: "Quantity",
                amount: "Amount",
                price: "Precio",
                attended_by: "Attended By",
                bottles_quantity: "Bottles Quantity",
                driver_placeholder: "Select a Driver",
                delivery_type_placeholder: "Select a Delivery Type",
                payment_type_placeholder: "Select a Payment Type",
                comment_placeholder: "Client's Notes",
            }
        },
        delivery_types: {
            label: "Delivery Type",
            search: {
                placeholder: "By name"
            },
            modal: {
                updated_label: "Updated @:delivery_types.label",
                updated_body: "@:delivery_types.label has been updated.",
                created_label: "Created @:delivery_types.label",
                created_body: "@:delivery_types.label has been created.",
                delete_label: "Delete @:delivery_types.label",
                delete_body: "Are you sure you want to delete this @:delivery_types.label"
            }
        },
        expenses: {
            label: "Expense"
        },
        expense_types: {
            label: "@:expenses.label Type",
            search: {
                placeholder: "By name"
            },
            modal: {
                updated_label: "Updated @:expense_types.label",
                updated_body: "@:expense_types.label has been updated.",
                created_label: "Created @:expense_types.label",
                created_body: "@:expense_types.label has been created.",
                delete_label: "Delete @:expense_types.label",
                delete_body: "Are you sure you want to delete this @:expense_types.label",
                deleted_label: "@:expense_types.label deleted.",
                deleted_body: "@:expense_types.label has been deleted."
            }
        }
    },
    es: {
        search: "Buscar:",
        import: "Importar",
        export: "Exportar",
        base_file: "Archivo Base",
        results: "Resultados",
        from: "Desde",
        to: "Hasta",
        filter: "Filtrar",
        comment: "Comentario",
        button: {
            create: "Crear",
            update: "Actualizar",
            edit: "Editar",
            details: "Detalles",
            delete: "Borrar",
            cancel: "Cancelar",
            accept: "Aceptar",
            activate: "Activar",
            options: "Opciones",
            back: "Volver",
            print: "Imprimir"
        },
        fields: {
            name: "Nombre",
            address: "Direccion",
            address2: "Apt/Piso",
            state: "Estado",
            city: "Ciudad",
            zipcode: "Zip Code",
            phone: "Telefono",
            phone2: "Tel. Adicional",
            order_frequency: "Frecuencia de Pedido",
            check_frequency: "Habilitar Frecuencia",
            active: "Activo",
            is_active: "Esta @:fields.active",
            inactive: "Inactivo",
            comment: "Comentario",
            price: "Precio",
            driver: "Chofer",
            order_date: "Fecha Orden",
            payment_type: "Tipo de Pago",
            amount: "Monto",
            attended_by: "Atendido por",
            expense: "Gasto",
            expense_type: "Tipo de @:fields.expense"
        },
        clients: {
            label: "Cliente"
        },
        orders: {
            label: "Orden",
            fields: {
                driver: "Chofer",
                order_date: "Fecha Orden",
                payment_type: "Tipo de Pago",
                delivery_type: "Tipo de Delivery",
                quantity: "Cantidad",
                amount: "Monto",
                price: "Precio",
                attended_by: "Atendido Por",
                bottles_quantity: "Cantidad de botellas",
                driver_placeholder: "Selecciona el chofer",
                delivery_type_placeholder: "Selecciona el tipo de delivery",
                payment_type_placeholder: "Selecciona el tipo de pago",
                comment_placeholder: "Notas del cliente",
            }
        },
        delivery_types: {
            label: "Tipo de Delivery",
            search: {
                placeholder: "By name"
            },
            modal: {
                updated_label: "@:delivery_types.label actualizado",
                updated_body: "@:delivery_types.label ha sido actualizado.",
                created_label: "@:delivery_types.label creado",
                created_body: "@:delivery_types.label ha sido creado.",
            }
        },
        expenses: {
            label: "Gasto",
            search: {
                placeholder: "By name"
            },
        },
        expense_types: {
            label: "Tipo de @:expenses.label",
            search: {
                placeholder: "By name"
            },
            modal: {
                updated_label: "@:expense_types.label Actualizado",
                updated_body: "@:expense_types.label ha sido actualizado.",
                created_label: "@:expense_types.label Creado",
                created_body: "@:expense_types.label ha sido creado.",
                delete_label: "Eliminar @:expense_types.label",
                delete_body: "Esta seguro que desea eliminar este @:expense_types.label",
                deleted_label: "@:expense_types.label eliminado.",
                deleted_body: "@:expense_types.label ha eliminado."
            }
        }
    }
}
